<template lang="pug">
  .vkb_nak.vkb_nak_vkb.vkb_nak_sponsoring
    .small-12.columns.pb-4(v-if="!email_sent" ref="heading")
      .row
        .small-12.columns
          p Wir freuen uns, dass Sie die Versicherungskammer gerne als Partner an Ihrer Seite hätten und sich mit Ihrer Anfrage an uns wenden. Bitte haben Sie jedoch Verständnis dafür, dass wir aufgrund der Vielzahl der Anfragen, die uns täglich erreichen, nur wenige Ausnahmen machen können. Auch bitten wir um Verständnis dafür, dass Einzelpersonen von uns keine Unterstützung erhalten können.
          h3.mt-3 Für welchen Bereich fragen Sie um eine Unterstützung an?

        .small-12.medium-6.large-4.columns.d-flex.align-center.mt-2(v-for="theme in themes" :key="theme.id")
          a.answer-selection(:class="themeId === theme.id && 'selected'" @click="onSelectTheme(theme.id)")
            i.fo.fo-person.fo-detail
            span.ml-2 {{ theme.text }}

      .row.mt-6(v-show="themeId === 1" ref="question-org")
        .small-12.columns
          h3 Welche Organisationsform hat die Feuerwehr?
          p Bitte beachten Sie, dass keine Förderung für eine Werk-/Betriebsfeuerwehr möglich ist.

        .small-12.medium-6.large-4.columns.d-flex.align-center.mt-2(v-for="organization in organizations" :key="organization.id")
          a.answer-selection(
            :class="organizationId === organization.id && 'selected'"
            @click="organizationId = organization.id"
          )
            i.fo.fo-person.fo-detail
            span.ml-2 {{ organization.text }}

      .row.mt-6(v-show="organizationId" ref="question-support")
        .small-12.columns
          h3 Welche Unterstützung möchten Sie?

        .small-12.columns.d-flex.align-center.mt-2(v-for="support in supports" :key="support.id")
          a.answer-selection(
            :class="supportId === support.id && 'selected'"
            @click="supportId = support.id"
          )
            i.fo.fo-person.fo-detail
            span.ml-2 {{ support.text }}

          .support-details.mt-2.pl-10(v-if="supportId === support.id" v-html="support.details")

      .row.mt-6(v-show="themeId > 1" ref="question-sponsor")
        .small-12.medium-12.large-7.columns.mt-3
          label.d-block Bitte skizzieren Sie Ihr Vorhaben und Ihre Organisation in wenigen Worten.
          textarea.input-details.mt-2.mb-2(v-model="organ_details" rows="3")
          .hint-wrapper(v-if="isInvalid('organ_details')")
            .hint.error.open {{ getErrorMessage('organ_details') }}

        .small-12.medium-12.large-7.columns.mt-3
          label.d-block Gerne prüfen wir Ihr Anliegen und setzen uns anschließend mit Ihnen in Verbindung. Bitte teilen Sie uns hierzu noch Ihre E-Mail-Adresse mit.
          n-text.input-email.mt-2(
            v-model="email"
            :error="getErrorMessage('email')"
          )

        .small-12.medium-12.large-7.columns.mt-3
          a.button.call-to-action.block(@click="onSendEmail") Anfrage abschicken

    .small-12.columns.pb-4(v-else)
      .row
        .small-12.columns.pt-5.pb-5
          h3 Vielen Dank. Wir prüfen Ihre Anfrage und melden uns anschließend bei Ihnen.

</template>

<script>
import logic from './logic.js';

export default {
  name: 'sponsoring',

  mixins: [
    logic,
  ]
};
</script>


// WEBPACK FOOTER //
// src/apps/sponsoring/vkb.vue